import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import CustomButton from '../../atoms/CustomButton';
import { useDispatch, useSelector } from 'react-redux';
import { getBrandListApi } from '../../redux/slice/brand/getBrandListSlice';
import { getCategoryListApi } from '../../redux/slice/category/getCategoryListSlice';

const SalesFilterSection = ({ getFilterValue, searchBrandCataGory }) => {
  const [allBrandList, setAllBrandList] = useState([]);
  const [allCategories, setAllCategories] = useState([]);

  const getBrandListState = useSelector((state) => state.getBrandListState);
  const getCategoryListState = useSelector((state) => state.getCategoryListState);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCategoryListApi());
    dispatch(getBrandListApi());
  }, [dispatch]);

  useEffect(() => {
    if (getBrandListState.status === 'success') {
      setAllBrandList(getBrandListState.data);
    }
  }, [getBrandListState.status]);

  useEffect(() => {
    if (getCategoryListState.status === 'success') {
      setAllCategories(getCategoryListState.data);
    }
  }, [getCategoryListState.status]);

  const handleCategorySelect = (category) => {
    // Reset brand selection when a category is selected
    getFilterValue(category);
  };

  const handleBrandSelect = (brand) => {
    // Reset category selection when a brand is selected
    getFilterValue(brand);
  };

  const isCategorySelected = (category) => {
    return (
      searchBrandCataGory &&
      allCategories.some((item) => item.categoryName === searchBrandCataGory) &&
      searchBrandCataGory === category
    );
  };

  const isBrandSelected = (brand) => {
    return (
      searchBrandCataGory &&
      allBrandList.some((item) => item.brandName === searchBrandCataGory) &&
      searchBrandCataGory === brand
    );
  };

  return (
    <div>
      {/* Top Section for Categories */}
      <Row gutter={[6, 6]} style={{ marginBottom: '10px' }}>
        <Col key={'All-categories'}>
          <CustomButton
            onClick={() => handleCategorySelect('')}
            type={
              searchBrandCataGory === '' || allCategories.every((item) => item.categoryName !== searchBrandCataGory)
                ? 'primary'
                : 'default'
            }
            size='large'
            loading={false}
            // style={{ width: '100%' }}
          >
            {'All categories'}
          </CustomButton>
        </Col>
        {allCategories.map((category, index) => (
          <Col key={index}>
            <CustomButton
              onClick={() => handleCategorySelect(category.categoryName)}
              type={isCategorySelected(category.categoryName) ? 'primary' : 'default'}
              size='large'
              loading={false}
              // style={{ width: '100%' }}
            >
              {category.categoryName}
            </CustomButton>
          </Col>
        ))}
      </Row>

      {/* Bottom Section for Brands */}
      <Row gutter={[8, 8]}>
        <Col key={'All-brands'}>
          <CustomButton
            onClick={() => handleBrandSelect('')}
            type={
              searchBrandCataGory === '' || allBrandList.every((item) => item.brandName !== searchBrandCataGory)
                ? 'primary'
                : 'default'
            }
            size='large'
            loading={false}
            // style={{ width: '100%' }}
          >
            {'All Brands'}
          </CustomButton>
        </Col>
        {allBrandList.map((brand, index) => (
          <Col key={index}>
            <CustomButton
              onClick={() => handleBrandSelect(brand.brandName)}
              type={isBrandSelected(brand.brandName) ? 'primary' : 'default'}
              size='large'
              loading={false}
              // style={{ width: '100%' }}
            >
              {brand.brandName}
            </CustomButton>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default SalesFilterSection;
